import { render } from "./GenericQuoteDetailsBlock.vue?vue&type=template&id=7ba04538&ts=true"
import script from "./GenericQuoteDetailsBlock.vue?vue&type=script&lang=ts"
export * from "./GenericQuoteDetailsBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__